function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.2796 12.7777L19.1403 11.387L20.9885 10.5427L24.1065 12.0415L22.2796 12.7777ZM18.3942 14.3437L10.0373 10.4962L18.3942 6.64929L27.946 10.4962L24.8839 11.7298L21.1049 9.91142C21.0218 9.87165 20.9302 9.87584 20.8523 9.92119L18.2734 11.1004C18.1662 11.1493 18.0948 11.2665 18.0948 11.3935C18.0948 11.5205 18.1656 11.6342 18.2753 11.6831L21.4783 13.1038L18.3942 14.3437ZM22.5758 17.5504V13.3295L24.589 12.518V16.7389L22.5758 17.5504ZM18.0945 26.7656L9.58697 22.8489V10.9734L18.0945 14.89V26.7656ZM18.679 26.7889V14.8993L21.9911 13.5652V18.0038C21.9911 18.1064 22.0385 18.2027 22.1177 18.262C22.1931 18.3178 22.2898 18.3352 22.3892 18.2962L24.9843 17.2509C25.0973 17.2055 25.1733 17.0869 25.1733 16.9571V12.282L28.4854 10.9478V22.8373L18.679 26.7889ZM9.00325 10.4196C9.00844 10.4196 9.0026 10.4573 9.0026 10.4942V23.0557C9.0026 23.182 9.07209 23.2951 9.17989 23.346L18.2719 27.532C18.3414 27.5627 18.418 27.5655 18.4901 27.5362L28.881 23.3495C28.9947 23.3041 29.07 23.1862 29.07 23.0557L29.0668 10.5312C29.057 10.4733 29.0538 10.4307 29.0505 10.3945L29.0031 10.3142C28.9654 10.2591 28.9271 10.2263 28.8862 10.2089L18.8077 6.02565C18.6992 5.99215 18.2453 5.99076 18.1323 6.02565L9.15781 10.2256C9.13768 10.2361 9.10456 10.2668 9.07404 10.31L9 10.4217C9.0013 10.4203 9.0026 10.4196 9.00325 10.4196V10.4196Z",
  fill: "#333333"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.74548 22.5L3.19117 23.3906C6.13851 29.2802 12.1596 33 18.7455 33V33V33C27.582 33 34.7455 25.8366 34.7455 17V17V17C34.7455 8.16344 27.582 1 18.7455 1V1H18.3292C11.4811 1 5.31719 5.15313 2.74548 11.5V11.5",
  stroke: "black",
  strokeWidth: 0.7
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1 7L2.56996 11.6749",
  stroke: "black",
  strokeWidth: 0.7
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.20443 11.6926C3.81412 11.1733 7.59825 9.97258 7.59825 9.97258",
  stroke: "black",
  strokeWidth: 0.7
});

var SvgReturnRequestedIcon = function SvgReturnRequestedIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReturnRequestedIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Return_requested_icon.abe062d6.svg";
export { ForwardRef as ReactComponent };